import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import { DateTime } from 'luxon'
import PropTypes from 'prop-types'

import { toggleArray } from '@campaignhub/javascript-utils'
import {
  Box, Button, Checkbox, Image, ListItemWithImage, StatusBadge, Text,
} from '@campaignhub/suit-theme'

import PageContext from '@contexts/pageContext'
import Icons from '@components/Icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'
import useResource from '@hooks/useResource'

const ListView = (props) => {
  const { callbacks: { toggleUpdateSelectedIds }, editable, content, selected, selectedIds } = props
  const { file } = content

  const { serviceJob, currentUser } = useContext(PageContext)

  const entities = useSelector(reduxState => reduxState.entities)
  const { serviceGroups } = entities

  const selectContent = (selectedContent) => {
    const currentlySelected = toggleArray(
      selectedIds.includes(selectedContent.id) ? selectedIds : selectedIds.filter(id => id !== selectedContent.id),
      selectedContent.id,
    ) || []

    toggleUpdateSelectedIds(currentlySelected)
  }

  const { callbacks: { launchEditResourceDetailModal } } = useResource({ id: content.id })

  return (
    <ListItemWithImage imageComponent={(
      <Box
        alignItems="center"
        as={content.previewUrl ? 'a' : null}
        borderRight={['none', '1px solid']}
        borderBottom={['1px solid', 'none']}
        borderColor={['lineColor', 'lineColor']}
        href={`${content.resourceUrl}`}
        justifyContent="center"
        padding="medium"
        style={{ textDecoration: 'none' }}
        width={['100%', 'fit-content']}
        target="_blank"
      >
        <Image
          boxProps={{ backgroundColor: 'hoverLightGrey' }}
          borderRadius={5}
          height={[180, '100%']}
          url={file.previewGeneratedAt ? content.previewUrl : ''}
          width={['100%', 200]}
        >
          {!file.previewGeneratedAt && (
            <Box
              alignItems="center"
              color="bodyFontColor"
              display="grid"
              justifyContent="center"
              width="100%"
            >
              <Icons name={serviceGroups[serviceJob.serviceGroupId]?.name} size={40} width="100%" />
            </Box>
          )}
        </Image>
      </Box>
    )}
    >
      <ListItemWithImage.Header>
        <ListItemWithImage.HeaderLeft>
          <ListItemWithImage.HeaderText>
            {file.displayName || file.originalName}
          </ListItemWithImage.HeaderText>
          <Text color="bodyFontLightColor" fontSize="xsmall">
            Date Uploaded: {DateTime.fromISO(file.createdAt, { zone: currentUser.timeZone }).toFormat('LL/dd/yyyy')}
          </Text>
        </ListItemWithImage.HeaderLeft>
        {editable && (
          <ListItemWithImage.HeaderRight>
            <Checkbox checked={selected} marginRight={0} onClick={() => selectContent(content)} />
          </ListItemWithImage.HeaderRight>
        )}
      </ListItemWithImage.Header>

      <ListItemWithImage.Footer>
        <ListItemWithImage.FooterLeft boxProps={{ maxWidth: '75%!important' }}>
          <Box fontSize="small" marginBottom="small">
            <StatusBadge
              color="mysteryGrey"
              text={content.resourceType?.description}
              boxProps={{ marginRight: 'small' }}
            />
            <StatusBadge
              color="mysteryGrey"
              text={file.fileType.name}
            />
          </Box>
          <Text color="bodyFontLightColor" fontSize="xsmall">
            {content.description || ''}
          </Text>
        </ListItemWithImage.FooterLeft>
        {editable && (
          <ListItemWithImage.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPencil} />}
              onClick={launchEditResourceDetailModal}
              size="medium"
              height={37}
            >
              Edit
            </Button>
          </ListItemWithImage.FooterRight>
        )}
      </ListItemWithImage.Footer>
    </ListItemWithImage>
  )
}

ListView.propTypes = {
  callbacks: PropTypes.object,
  content: PropTypes.object.isRequired,
  editable: PropTypes.bool,
  selected: PropTypes.bool,
  selectedIds: PropTypes.array,
}

export default ListView
